<template>
<div class="login-page bg-00dp">
	<Loader :show="loading"></Loader>
	<div class="login ">
		<div class="text-center">
			<img src="@/assets/logo.png" alt="" class="logo img-fluid mb-4">
			<!-- <h3>Ingreso</h3> -->
			<!-- <p>Ingresá a tu cuenta con tu email y contraseña</p> -->
			<form @submit.prevent="login" class="mt-4">
				<div class="row">
					<div class="col-12">

						<FormulateForm
							v-model="form"
							@submit="login()"
							>
							<FormulateInput
								name="email"
								type="email"
								placeholder="Ingrese su email"
								validation="required|email"
								:wrapper-class="['login-input']"
							/>
							
							<FormulateInput
								name="password"
								type="password"
								placeholder="Ingrese su contraseña"
								validation="required"
							/>
							
							<button class="btn btn-primary btn-block btn-lg mt-4" type="submit" >
								<span v-if="loginIn">Ingresando...</span>
								<span v-if="!loginIn">Ingresar</span>
							</button>
							
						</FormulateForm>

						
						<hr>
						<p class="text-center text-white"><small>Si tienes problemas para ingresar a tu cuenta, ponete en contacto con nosotros.</small></p>
					</div>
				</div>
				
			</form>
		</div>
	</div>
</div>
</template>

<script>
import gql from 'graphql-tag'
import { onLogin } from '../vue-apollo';
import { mapMutations } from 'vuex'
import Loader from '@/components/layout/Loader'

export default {
	name: 'Login',
	components:{
		Loader
	},
    data() {
        return {
			loading: true,
			form:{},
            loginError:false,
            loginIn:false,
        }
	},
	mounted(){
		this.loading=  false
	},
    methods: {
		...mapMutations(['authSuccess','logout']),
		login() {
            this.loginError=false
            if( !this.loginIn && this.email !='' && this.password!='' ){
                this.loginIn = true

				return this.$apollo.mutate({
                    mutation: gql`mutation userLogin($email:String!, $password:String!, $accessTo: String! ){
                        userLogin( email: $email, password: $password, accessTo: $accessTo ){
                            token
							user{
								id
								name
								email
							}
                        }
                    }`,
                    variables: {
                        email: this.form.email,
						password: this.form.password,
						accessTo: 'app'
                    },
                })
                .then( data => {
					let access_token = data.data.userLogin.token
                    let logged_user = data.data.userLogin.user
                    onLogin(this.$apollo.provider.defaultClient, access_token, logged_user).then(() => { 
                        this.authSuccess({token:access_token, loggedUser: logged_user})
                        this.loginIn = false
                        this.$router.push('/')
                    });
                })
                .catch((errors) => {
					this.parseGQLErrors(errors)
					this.loginError = true
					this.loginIn = false
				});
			}
		}
    }
}
</script>

<style>
.login-page{
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	height: 100vh;
	color: #fff;
}
.login .logo{
	margin: 0px auto;
	display: block;
	max-width: 180px;
}
.login h3{
	font-size:14px;
	font-weight: 600;
	text-transform: uppercase;
}
.login{
	text-align: left;
	max-width: 320px;
	padding: 16px;
}
.login .formulate-input{
	margin-bottom: 8px !important;
}
.login .formulate-input-label{
	color:#fff !important;
}
.login input{ 
	background-color: #ffffff15 !important;
    color: #fff;
    border: none !important;
    font-size: 14px !important;
    padding: .85rem !important;
}
</style>
